import React from 'react'
import BaseComponent from './BaseComponent'
import { NavLink } from 'react-router-dom'
import _ from 'lodash'

export default class extends BaseComponent {

  render() {
    const settings = this.props.settings[0]

    let navItems = _.filter(this.props.data.nav, { position: "footer" })

    let nav = navItems.map((item, i) => {
      let items = item.items.map((itemj, j) => {
        return (
            <li key={ j }><NavLink to={ itemj.value }>{ itemj.title }</NavLink></li>
        )
      })

        return (
            <div key={ i } className="nav">
                <h4>{ item.name }</h4>
                <ul>
                    { items }
                </ul>
            </div>
        )
    })

    return (
      <footer className="footer">
        <div className="footer-top">
        	<div className="container-big">
        		<NavLink to="/"><img className="logo-footer" src="/assets/img/logo-footer.png" alt="Ekostar Logo Footer"/></NavLink>
        		<ul className="social">
        			<li><a href={ settings.fb } target="_blank" rel="noopener noreferrer"><img src="/assets/img/fb-f.png" alt="Ikona Facebook"/></a></li>
        			<li><a href={ settings.insta } target="_blank" rel="noopener noreferrer"><img src="/assets/img/in-f.png" alt="Ikona Instagram"/></a></li>
        			<li><a href={ settings.yt } target="_blank" rel="noopener noreferrer"><img src="/assets/img/yt-f.png" alt="Ikona Youtube"/></a></li>
        		</ul>
        	</div>
        </div>
        <div className="footer-nav">
        	<div className="container-big">
        		{ nav }
        	</div>
        </div>
        <div className="footer-bottom">
        	<div className="container-big">
        		<p className="copyrights">© 2018 Eko Star Kratka Trawnikowa</p>
        		<p className="we-made-this">Projekt i Wykonanie Lato Warsaw Sp. z o.o.<a href="https://latowarsaw.pl" target="_blank" rel="noopener noreferrer"><img className="logo-lato" src="/assets/img/logo-lato.png" alt="Lato logo"/></a></p>
        	</div>
        </div>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Footer.js